import { useEffect, type ReactNode } from 'react';
import { refreshSession } from '@/lib/api-client';
import { useAuthStore } from '@/stores/auth-store';

/**
 * Restaura a sessão ao carregar a aplicação (refresh via cookie HttpOnly).
 * Enquanto `status === 'loading'`, as rotas protegidas exibem um splash.
 */
export function AuthProvider({ children }: { children: ReactNode }) {
  const status = useAuthStore((s) => s.status);
  const setStatus = useAuthStore((s) => s.setStatus);

  useEffect(() => {
    if (status !== 'idle') return;
    setStatus('loading');
    void refreshSession();
  }, [status, setStatus]);

  return <>{children}</>;
}
